var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detailHead" }, [
    _c("div", { staticClass: "acea-row row-between headerBox" }, [
      _c("div", { staticClass: "full" }, [
        _c("div", { staticClass: "order_icon" }, [
          _c("span", { staticClass: "iconfont", class: _vm.icon }),
        ]),
        _c("div", { staticClass: "text" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm.titleLable
            ? _c("div", [
                _c(
                  "span",
                  {
                    staticClass: "mr20",
                    class: _vm.colClass ? _vm.colClass : "",
                  },
                  [_vm._v(_vm._s(_vm.titleLable))]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "acea-row justify-content" },
        [_vm._t("operation")],
        2
      ),
    ]),
    _vm.list.length
      ? _c(
          "ul",
          { staticClass: "list" },
          _vm._l(_vm.list, function (item, index) {
            return _c("li", { key: index, staticClass: "item" }, [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.label))]),
              _c("div", { class: item.color }, [_vm._v(_vm._s(item.value))]),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }